module.exports = __webpack_public_path__ + "static/media/speakers.1d1feaf2.svg";